var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0135 24.639C20.0336 21.6746 22.8848 17.7711 22.8848 14.0681C22.8848 10.2155 19.9068 7.45898 16 7.45898C12.0932 7.45898 9.11523 10.2155 9.11523 14.0681C9.11523 17.7955 11.7104 21.4252 16.0135 24.639ZM16 27C20.7452 23.8544 24.8125 19.0868 24.8125 14.0681C24.8125 9.04929 20.867 5.53125 16 5.53125C11.133 5.53125 7.1875 9.04929 7.1875 14.0681C7.1875 19.0868 10.9159 23.5049 16 27Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4058 13.0767L19.2941 18.0346L19.7255 15.9315L21.7638 15.2124L16.4058 13.0767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8206 15.2119H11.0439L12.6654 16.6339L12.2742 18.7424L16.8206 15.2119Z",
    fill: "#ABE1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7457 14.5002L17.634 9.54408L15.5811 10.2252L13.9341 8.83398L14.7457 14.5002Z",
    fill: "#FFC20E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 5.9375,
    y: 4.90625,
    width: 20.125,
    height: 23.9688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0677778 0 0 0 0 0.21776 0 0 0 0 0.266667 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DD2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#408E8D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon);
export default __webpack_public_path__ + "static/media/footer_icon.86bade0a0289f633f97c18db3cefef75.svg";
export { ForwardRef as ReactComponent };